<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1" id="epig"> </p>
<p class="FM-Epigraph---verse-fmepiv">Love is a flame; we have beaconed the world’s night.</p>
<p class="FM-Epigraph-Source-fmeps"><span class="ePub-I">—Rupert Brooke</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?5fca676e